import { useQuery } from '@tanstack/react-query';
import transactionService from '../api/transactionService';

export const useAdminTransactions = (params) => {
    return useQuery({
        queryKey: ['adminAllTransactions', params],
        queryFn: () => transactionService.adminGetTransactions(params),
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000 // cache for 5 minutes
    });
};

export const useVendorTransactions = (params) => {
    return useQuery({
        queryKey: ['vendorAllTransactions', params],
        queryFn: () => transactionService.vendorGetTransactions(params),
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000 // cache for 5 minutes
    });
};
